module.exports = __webpack_public_path__ + "static/media/recruitment-image-mobile.e9cfb75f.jpg";